let throttle = require('lodash/throttle');

module.exports = {
	init: function () {
		const header = document.querySelector('header');
		const mobileBackground = header.querySelector('.mobile-background');

		// defining a specific instance of debounce to cancel if need be
		let throttle500 = throttle(function () {
			if (window.innerWidth >= 1300) {
				if (window.pageYOffset > 0) {
					header.style.backgroundColor = '#01778e';
				} else {
					header.style.backgroundColor = 'transparent';
				}
			} else {
				// header.style.backgroundColor = 'transparent';
				// if (window.pageYOffset > 0) {
				// 	mobileBackground.style.backgroundColor = '#01778e';
				// } else {
				// 	mobileBackground.style.backgroundColor = 'transparent';
				// }
			}
		}, 500);

		document.addEventListener('scroll', throttle500);
		window.addEventListener('resize', throttle500);
		throttle500();
	},
};
